import React from 'react'

import { type BaseProps, ComboBox, type LabelProps } from './internal/ComboBox'
import type { MenuOptionVariantSelectable } from './MenuOption'

type Props<
  TOption extends MenuOptionVariantSelectable = MenuOptionVariantSelectable
> = Omit<BaseProps<TOption>, 'variant'> & LabelProps

/**
 * The `Autocomplete` is a dropdown that allows the user to select from a list of options.
 */
export function Autocomplete<
  TOption extends MenuOptionVariantSelectable = MenuOptionVariantSelectable
>(props: Props<TOption>) {
  return <ComboBox<TOption> {...props} />
}
